import * as t from "io-ts";
import fetchApi from "ui-io/fetch-api";

export type ChangePasswordRequestT = {
  userId: string;
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export const changeUserPassword = (payload: ChangePasswordRequestT) => {
  return fetchApi({
    service: "user-service",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    pathname: "/change-password/",
    codec: t.type({userId: t.string}),
    body: payload,
  });
};
